export const ALL = 'ALL';
export const CUSTOM = 'CUSTOM';

export const AND = 'AND';
export const OR = 'OR';

export const CRITICAL = 'CRITICAL';
export const WARNING = 'WARNING';
export const DEBUG = 'DEBUG';
export const INFO = 'INFO';

export const ALERT_TAG_GROUP_TABLE_LIMIT = 30;

export const DEFAULT_SORT_BY = 'lastUpdatedAt';
export const ASC = 'ASC';
export const DESC = 'DESC';
export const ACTIONS = 'actions';

export const ALLOWED_CUST_EXP_CHAR_REGEX = /^[A-Z\s()]+$/;
export const EMPTY_PARANTHESES_REGEX = /\(\s*\)/;
export const EXP_ORDER_REGEX = /^\s*[A-Z]+(\s+(AND|OR)\s+[A-Z]+)*\s*$/;
